/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit None/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function None({
  children,
  viewPath = "/App/Form/Data/ProvideData/AppointmentSlot/Notifications/None"
  
}) {
  return null
}